import { CardContent, Stack, Typography } from '@mui/material'

import { AuthForm } from '../../components'
import { RouterLinkUI } from '../../components/SharedUI/RouterLinkUI'
import { AppRoutes } from '../../models'

export const LoginCard = ({ isDvi }: { isDvi?: boolean }) => {
  return (
    <CardContent>
      <Stack spacing={4} alignItems="center">
        <Typography variant="h4">Welcome Back</Typography>
        <AuthForm
          isLogin
          submitLabel="Sign In"
          submitLoadingLabel="Signing In..."
          isDvi={isDvi}
        />
        <Typography>
          <Typography color="grey" component={'span'}>
            Need to create an account?&nbsp;&nbsp;
          </Typography>
          <RouterLinkUI to={isDvi ? AppRoutes.DVI_SIGNUP : AppRoutes.SIGNUP}>
            <Typography variant="subtitle1" component={'span'}>
              Sign Up
            </Typography>
          </RouterLinkUI>
        </Typography>
      </Stack>
    </CardContent>
  )
}
